import React from "react";
import { getInitials } from "@/lib/roll";
import { OPERATOR_ICONS } from "@/data/operators";

/**
 * Stylized SVG emblem as a placeholder for operator icons.
 * Uses real icon from OPERATOR_ICONS map when available; falls back to initials.
 * `size` is in px. `side` = "attacker" | "defender".
 */
export const OperatorEmblem = ({ id, name, side = "attacker", size = 144 }) => {
  const color = side === "attacker" ? "#E67300" : "#1F88E8";
  const initials = getInitials(name);
  const viewBox = 200;
  const half = viewBox / 2;
  const iconEntry = id ? OPERATOR_ICONS[id] : null;
  const iconUrl = typeof iconEntry === "string" ? iconEntry : iconEntry?.url || null;

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid={`operator-emblem-${side}`}
    >
      <svg
        viewBox={`0 0 ${viewBox} ${viewBox}`}
        width={size}
        height={size}
        className="absolute inset-0"
        aria-hidden="true"
      >
        {/* Outer hexagon-ish diamond */}
        <polygon
          points={`${half},10 190,${half} ${half},190 10,${half}`}
          fill="transparent"
          stroke={color}
          strokeWidth="2"
        />
        {/* Inner diamond */}
        <polygon
          points={`${half},28 172,${half} ${half},172 28,${half}`}
          fill={color}
          fillOpacity="0.08"
          stroke={color}
          strokeWidth="1"
          strokeDasharray="3 3"
        />
        {/* Corner ticks */}
        <line x1={half} y1="0" x2={half} y2="14" stroke={color} strokeWidth="2" />
        <line x1={half} y1={viewBox - 14} x2={half} y2={viewBox} stroke={color} strokeWidth="2" />
        <line x1="0" y1={half} x2="14" y2={half} stroke={color} strokeWidth="2" />
        <line x1={viewBox - 14} y1={half} x2={viewBox} y2={half} stroke={color} strokeWidth="2" />
      </svg>
      {iconUrl ? (
        <img
          src={iconUrl}
          alt={name}
          className="relative select-none"
          style={{
            width: size * 0.7,
            height: size * 0.7,
            objectFit: "contain",
          }}
          draggable={false}
        />
      ) : (
        <span
          className="relative font-black tracking-tight"
          style={{
            fontFamily: '"Barlow Condensed", sans-serif',
            fontSize: size * 0.38,
            color: color,
            lineHeight: 1,
          }}
        >
          {initials}
        </span>
      )}
    </div>
  );
};

export default OperatorEmblem;
